import { FC, InputHTMLAttributes, memo } from 'react';
import { Input } from 'components/common/Input';
import s from './SearchInput.module.scss';
import { ReactComponent as Loop } from 'images/loop.svg';
import { ReactComponent as Send } from 'images/send.svg';
import { t } from 'i18next';

const icons = {
  loop: <Loop />,
  send: <Send />,
};

type SearchInputProps = {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  className?: string;
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'placeholder'
>;

export const SearchInput: FC<SearchInputProps> = memo(
  ({
    value,
    onChange,
    placeholder = t('common.search'),
    className,
    ...props
  }) => {
    return (
      <div className={`${s.search} ${className || ''}`}>
        {icons.loop}
        <Input
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={s.input}
          {...props}
        />
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';
